'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (palette) {
    return {
        background: palette.elDivider,
        width: '100%',
        height: '1px'
    };
};